// extracted by mini-css-extract-plugin
export default {"auroraContainer":"Aurora_auroraContainer__6M1p-"};